package top.wcpe.allincore.dsl.compiler.source

/** 冻结的逻辑源码路径算法，不访问文件系统。 */
object LogicalSourcePath {
    private val schemePrefix = Regex("^[A-Za-z][A-Za-z0-9+.-]*:")

    fun normalize(path: String): String {
        require('\u0000' !in path) { "逻辑路径不得包含 NUL" }
        require(!schemePrefix.containsMatchIn(path)) { "逻辑路径不得包含 URI scheme 或盘符" }
        require(path.firstOrNull() != '/' && path.firstOrNull() != '\\') { "逻辑路径不得为绝对路径" }

        val segments = mutableListOf<String>()
        for (segment in path.replace('\\', '/').split('/')) {
            when (segment) {
                "", "." -> Unit
                ".." -> {
                    require(segments.isNotEmpty()) { "逻辑路径不得越过逻辑根" }
                    segments.removeAt(segments.lastIndex)
                }
                else -> segments += segment
            }
        }
        require(segments.isNotEmpty()) { "规范化逻辑路径不得为空" }
        return segments.joinToString("/")
    }

    fun sort(paths: Collection<String>): List<String> = paths.sorted()
}
